

<template>
  <div class="v-data-footer">
    <v-spacer></v-spacer>

    <div class="v-data-footer__select">
      <span class="qmkey-item-row"> Items per page </span>
      <v-select
        v-model="items_per_page_model"
        dense
        hide-details
        :value="items_per_page"
        @change="change_items_per_page"
        :items="per_page_choices"
        :disabled="!allow_change_items_per_page"
        height="32"
      >
      </v-select>

      <span class="pl-2 qmkey-item-row">
        {{ (current_page - 1) * items_per_page + 1 }} -
        {{ (current_page - 1) * items_per_page + units_length }} of
        {{ total_units }}
      </span>

      <ul class="pagination">
        <li class="pagination-item">
          <v-btn
            @click="on_click_first_page"
            :disabled="is_in_first_page"
            icon
            small
          >
            <v-icon>{{ first_page_icon }}</v-icon>
          </v-btn>
        </li>

        <li class="pagination-item">
          <v-btn
            @click="on_click_previous_page"
            :disabled="is_in_first_page"
            icon
            small
          >
            <v-icon>{{ previous_page_icon }}</v-icon>
          </v-btn>
        </li>

        <!-- Visible Buttons Start -->

        <li v-for="page in pages" :key="page.name" class="pagination-item">
          <v-btn
            @click="on_click_page(page.name)"
            :disabled="page.is_disabled"
            :class="{ 'btn-active': is_page_active(page.name) }"
            icon
            small
          >
            {{ page.name }}
          </v-btn>
        </li>

        <!-- Visible Buttons End -->

        <li class="pagination-item">
          <v-btn
            @click="on_click_next_page"
            :disabled="is_in_last_page"
            small
            icon
          >
            <v-icon>{{ next_page_icon }}</v-icon>
          </v-btn>
        </li>

        <li class="pagination-item">
          <v-btn
            @click="on_click_last_page"
            :disabled="is_in_last_page"
            icon
            small
          >
            <v-icon>{{ last_page_icon }}</v-icon>
          </v-btn>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QPagination',
  props: {
    max_visible_buttons: {
      type: Number,
      required: false,
      default: 3,
    },
    current_page: {
      type: Number,
      required: true,
    },
    total_units: {
      type: Number,
      required: true,
    },
    allow_change_items_per_page: {
      type: Boolean,
      required: false,
      default: false,
    },
    per_page_choices: {
      type: Array,
      required: false,
      default: () => [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '15', value: 15 },
        { text: 'All', value: -1 },
      ],
    },
    items_per_page: {
      type: Number,
      required: false,
      default: 10,
    },
    units_length: {
      type: Number,
      required: false,
      default: 10,
    },
    first_page_icon: {
      type: String,
      required: false,
      default: 'mdi-page-first',
    },
    previous_page_icon: {
      type: String,
      required: false,
      default: 'mdi-chevron-left',
    },
    last_page_icon: {
      type: String,
      required: false,
      default: 'mdi-page-last',
    },
    next_page_icon: {
      type: String,
      required: false,
      default: 'mdi-chevron-right',
    },
  },
  data: () => ({
    items_per_page_model: 10,
  }),
  computed: {
    start_page() {
      // When on the first page
      if (this.current_page === 1) {
        return 1
      }

      // When on the last page
      if (this.current_page === this.total_pages) {
        return this.total_pages - this.max_visible_buttons + 1
      }

      // When in between
      return this.current_page - 1
    },
    total_pages() {
      return Math.ceil(this.total_units / this.items_per_page)
    },

    pages() {
      const range = []

      for (
        let i = this.start_page;
        i <=
        Math.min(
          this.start_page + this.max_visible_buttons - 1,
          this.total_pages,
        );
        i++
      ) {
        range.push({
          name: i,
          is_disabled: i === this.current_page,
        })
      }

      return range
    },
    is_in_first_page() {
      return this.current_page === 1
    },
    is_in_last_page() {
      return this.current_page === this.total_pages
    },
  },
  methods: {
    on_click_first_page() {
      this.$emit('page_changed', 1)
    },
    on_click_previous_page() {
      this.$emit('page_changed', this.current_page - 1)
    },
    on_click_page(page) {
      this.$emit('page_changed', page)
    },
    on_click_next_page() {
      this.$emit('page_changed', this.current_page + 1)
    },
    on_click_last_page() {
      this.$emit('page_changed', this.total_pages)
    },
    change_items_per_page() {
      this.$emit('items_per_page_changed', this.items_per_page_model)
    },
    is_page_active(page) {
      return this.current_page === page
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/qpagination.scss';
@import "@/sass/explorer.scss";
</style>